import { createSelector } from "reselect";
import { SCOPE } from "./types";

const selector = state => state[SCOPE];

export const summaryWidgetsSelector = createSelector(
  selector,
  (state) => state
);

export default selector;
